  <template>
  <div class="users-style">
	<div style="margin-bottom: 20px;">
	  <h2>All Pay Slips</h2>
	</div>
	<table class="table table-bordered table-striped table-hover">
	  <thead>
		<tr>
		  
		  <td style="min-width:150px;"><select id="employee_id" v-model="search.employee_id" class="form-control " @change="setSearch()">
						<option value="">Select Employee</option>
						 <option v-for='emply in employees'  :value='emply.employee_id'>{{ emply.name }}</option>
						</select>
		  </td>
		  <td><input class="form-control" type="text" v-model="search.pay_slip_name" placeholder="Pay Slip Name"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.pay_slip_ref" placeholder="Pay Slip Ref."@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.month" placeholder="Month"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.year" placeholder="Year"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.fiscal_year" placeholder="Fiscal Year"@input="setSearch()"></td>
		  <td><select id="employee_id" v-model="search.status" class="form-control " @change="setSearch()">
						<option value="">Select Status</option>
						<option value="0">Draft</option>
						 <option value="1">Confirmed</option>
						</select></td>

		  <td></td>
		</tr>
	  </thead>
	  <tbody>
		<tr v-for="pslip in payslips" :key="pslip.id">
		  <td><a :href="$api_url+'/payslip-detail/'+pslip.id+''" target="_blank">{{pslip.employee_id}}</a></td>
		  <td>{{pslip.pay_slip_name}}</td>
		  <td>{{pslip.pay_slip_ref}}</td>
		  <td>{{pslip.month}}</td>
		  <td>{{pslip.year}}</td>
		  <td>{{pslip.fiscal_year}}</td>
		  <td>{{pslip.status}}</td>
		  <td><a class="btn btn-primary" :href="$api_url+'/payment-slip/'+pslip.id+''" target="_blank">Edit</a>
		  </td>
		</tr>
	  </tbody>
	  <tfoot>
		<tr>
		  <td colspan="5"><span class="page-stats">{{pagination.from}} - {{pagination.to}} of {{pagination.total}}</span>
			<button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.prebuttonstatus" @click="setPagination(false)" > Prev </button>
			<button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.nextbuttonstatus"   @click="setPagination(true)"> Next </button>
			<select class="input" type="text" v-model="per_page" @change="setSearch()">
			  <option value="5">5</option>
			  <option value="10">10</option>
			  <option value="20">20</option>
			</select></td>
		</tr>
	  </tfoot>
	</table>
  </div>
  </template> 
  <script>
	  export default{
		  props: [],
		  mounted() {
			  console.log('started..');            
		  },
		  data(){
			  return {
				  payslips : [],  
				  employees : [],              
				  pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
				  search:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:''},
				 // search_by_id:{company_employee:''},
				  per_page:10,                
				  
  
			  }
		  },
		  methods:{
		  
		  getEmployees: function()
			  {
  
						  axios.get(this.$api_url+'/getemployees' , {
							  params: {
								  page: 1,
								  per_page: 1000000,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.employees = response.data.data;
  
  
				  }.bind(this));
			  },
			
			  setSearch: function(pageflg)
			  {
				  this.pagination.currentPage = 1;
				  this.getpayslips();
			  },
			  setPagination: function(pageflg)
			  {                
				  if(pageflg)
					  this.pagination.currentPage = this.pagination.nextPage;
				  else    
					  this.pagination.currentPage = this.pagination.prevPage;
				  
				  this.getpayslips();
			  },
			  getpayslips: function()
			  {
  
						  axios.get(this.$api_url+'/list-payslips' , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: this.per_page,
								  search_query: this.search,
								  search_query_by_id: this.search_by_id,
							  }
					  }).then(function(response){
					  this.payslips = response.data.data;
  
					  this.pagination.from = response.data.from;
					  this.pagination.to = response.data.to;
					  this.pagination.total = response.data.total;
					  
					  if(this.pagination.to==this.pagination.total)
					  {
						  
						  this.pagination.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.pagination.nextbuttonstatus = '';
					  }
					  
					  if(this.pagination.from==1)
					  {
					  this.pagination.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.pagination.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.pagination.currentPage < response.data.last_page)
						  this.pagination.nextPage = this.pagination.currentPage + 1;
  
					  if(this.pagination.currentPage == 1)
						  this.pagination.prevPage = 1;
					  else 
						  this.pagination.prevPage = this.pagination.currentPage - 1;
				  }.bind(this));
			  },
			 
  
  
		  },
		  created: function(){
		      this.getEmployees();
			  this.getpayslips();
		
		  }
	  }
  </script>
  <style>
  button.disabled{
	  cursor: default;
  }
  
  </style>